// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"11ca0586","977":"dd9f1f73"}[chunkId] + ".chunk.js";
};